const logger = (store) => (next) => (action) => {
  if (process.env.NODE_ENV === "development") {
    console.group(action.type || "logger");
    console.info("dispatching", action);
    let result = next(action);
    console.log("next state", store.getState());
    console.groupEnd();
    return result;
  }
  return next(action);
};

export default logger;
